import * as React from "react";
import styled from "styled-components";
import axios from 'axios';
import { useNavigate, useLocation } from "react-router-dom"; // Import useLocation
import FeatureImageYellow from '../../assets/feature_image_yellow.png'
import HamburgerIcon from '../../assets/hamburger-icon.png'; // Assuming you have a hamburger icon
import { useGoogleLogin } from '@react-oauth/google';
import Modal from '@mui/material/Modal'; // Importing Modal for confirmation
import { API_BASE_URL } from '../../config/apiConfig';
import { socialIcon, featureImage, profileImage } from '../../assets/images';

export function Wall() {
  const navigate = useNavigate();
  const location = useLocation(); // Get location to check for state
  const [showProfileDetails, setShowProfileDetails] = React.useState(false);
  const [showSubscription, setShowSubscription] = React.useState(false);
  const [showLists, setShowLists] = React.useState(false);
  const [showDealsboard, setShowDealsboard] = React.useState(location.state?.merch || false);
  const [showWallofElts, setShowWallofElts] = React.useState(location.state?.elts || false); // Enable showWallofElts based on state
  const [profile, setProfile] = React.useState(null);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);


  
  const handleShare = (platform) => {
    const url = "https://spoelt.me"; // Replace with the URL you want to share
    const message = `We curate unmatchable deals exclusively for our community members, with a priority on 'Authentic' products and 'Lowest' prices.
      
    Join us to 'Never pay retail price again, Period.'`; 
    if (platform === 'whatsapp') {
      window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)} ${encodeURIComponent(url)}`, '_blank');
    } else if (platform === 'instagram') {
      // Instagram sharing is limited; typically, you can only share to stories via a link
      window.open(`https://www.instagram.com/?url=${encodeURIComponent(url)}`, '_blank');
    }
  };
  
  
  
  return (
    <ProfileContainer style={{ backgroundColor: (showWallofElts) ? '#e9fe53' : 'transparent', height: '100vh' }}>
      <HeaderContainer>
        <ProfileImage loading="lazy" src={profileImage} onClick={() => navigate("/")} />
        <Hamburger onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <HamburgerImg src={HamburgerIcon} alt="Menu" />
        </Hamburger>
      </HeaderContainer>
      <Nav $isOpen={isMenuOpen} $isActive={!(showDealsboard || showWallofElts)}>
        <CloseButton hidden={!isMenuOpen} onClick={() => setIsMenuOpen(false)}>Close x</CloseButton>
        <NavItem onClick={() => { window.location.href = '/'; }}>Home</NavItem>
        <NavItem isActive={!(showWallofElts) && showDealsboard} onClick={() => { setShowDealsboard(true); setShowWallofElts(false); setIsMenuOpen(false); }}>Merch</NavItem>       
        <NavItem style={{ backgroundColor: showWallofElts ? 'white' : 'transparent' }} onClick={() => { setShowDealsboard(false); setShowWallofElts(true); setIsMenuOpen(false); }}>Wall of ELTS</NavItem>
        <NavItem onClick={() => { window.location.href = '/about'; }}>About Us</NavItem>
      </Nav>
      {showDealsboard && <Dealsboard />}
      {showWallofElts && <WallofElts />}
      <SocialSection>
        <SocialLink>
          <SocialLabel>Follow us on our socials:</SocialLabel>
          <SocialIcon loading="lazy" src={socialIcon} />
          <SocialText>@im_spoelt</SocialText>
        </SocialLink>
        <Footer>Copyright © 2024. SPOELT. All rights reserved</Footer>
      </SocialSection>
    </ProfileContainer>
  );
}

function Dealsboard( ) {
  const navigate = useNavigate();
  const location = useLocation(); // Get location to check for state
  const [showModal, setShowModal] = React.useState(false); // State for modal visibility
  const [modalOpen, setModalOpen] = React.useState(false); // State to handle modal visibility
  const [snackbarOpen, setSnackbarOpen] = React.useState(false); // State to handle Snackbar visibility
  const [snackbarMessage, setSnackbarMessage] = React.useState(''); // State to store Snackbar message
 
  const [user, setUser] = React.useState([]);
  const [email, setEmail] = React.useState(sessionStorage.getItem('email') || ''); // State to store email from sessionStorage
  const handleUseDifferentEmail = () => {
    setModalOpen(false);
    handleJoinTheClubClick();
  };

  React.useEffect(() => {
    const token = sessionStorage.getItem('token');
    if (token) {
        axios({
            method: 'post',
            url: `${API_BASE_URL}/user/get-profile`,
            headers: {
                Authorization: token
            }
        }).then(response => {
            console.log(response.data);
          //  setProfile(response.data.data[0]);
        }).catch(error => {
            console.error('Error fetching profile', error);
        });
    }
   
    
   
    // Check if redirected from shipping page
    if (location.state && location.state.fromShipping) {
      setShowModal(true); // Show modal if coming from shipping page
    }
  }, [location.state]);
  const handleJoinTheClubClick = useGoogleLogin({
    onSuccess: (codeResponse) => setUser(codeResponse),
    onError: (error) => console.log('Login Failed:', error)
  });
  React.useEffect(
    () => {
      if (user) {
        console.log(user)
        axios
          .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`, {
            headers: {
              Authorization: `Bearer ${user.access_token}`,
              Accept: 'application/json'
            }
          })
          .then((res) => {
            console.log(res)
            login(res.data)
          })
          .catch((err) => console.log(err));
      }
    },
    [user]
  );
  const checkTokenAndLogin = async () => {
    const existingEmail = sessionStorage.getItem('email');
    const token = sessionStorage.getItem('token');
    if (token && existingEmail) {
      // If email exists in session storage, show modal
      setModalOpen(true);
    } else {
      // Proceed with login if no email in session storage
      handleJoinTheClubClick();
    }
  };
  const login = async (user) => {
    console.log('loginapi:', user)
    try {
      const response = await axios.post(`${API_BASE_URL}/user/login`, {
        user: {
          name: user.name,
          email: user.email,
          id: user.id,
          profile_image: user.image
          // Other user data you might need
        },
      });
      console.log(response.data)
      if (response.data.is_success) {
        if (response.data.token) {
          axios({
            method: 'post',
            url: `${API_BASE_URL}/user/get-profile`,
            headers: {
              Authorization: response.data.token
            }
          }).then(res => {
            console.log(res.data);

            console.log(res.data.data[0]);
            if (res.data.data[0].needList?.length > 0) {
              sessionStorage.setItem('token', response.data.token);
              sessionStorage.setItem('email', user.email); // Save email in session storage

              navigate('/profile');
            } else {
              sessionStorage.setItem('token', response.data.token);
              sessionStorage.setItem('email', user.email); // Save email in session storage
              navigate('/personalDetails');

            }

          }).catch(error => {
            console.error('Error fetching profile', error);
          });
        }

      } else {
        // Handle login failure
        setSnackbarMessage('Login failed. Please try again.');
        setSnackbarOpen(true);
      }
      return response.data;
    } catch (error) {
      console.error("Error registering user:", error);
      setSnackbarMessage('Login failed. Please try again.');
      setSnackbarOpen(true);
      return null;
    }
  };
  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleUseSameEmail = () => {
    setModalOpen(false);
    const token = sessionStorage.getItem('token');
    axios({
      method: 'post',
      url: `${API_BASE_URL}/user/get-profile`,
      headers: {
        Authorization: token
      }
    }).then(res => {
      console.log(res.data);

      console.log(res.data.data[0]);
      if (res.data.data[0].needList?.length > 0) {
       
        navigate('/profile');
      } else {
        navigate('/personalDetails');

      }

    }).catch(error => {
      console.error('Error fetching profile', error);
      handleJoinTheClubClick();
    }); // Proceed with the same email
  };
  return (
    <div style={{ position: 'relative' }}>
      <MainHeading>Coming soon </MainHeading>
      <FeatureImage src={featureImage} alt="Feature" loading="lazy" />
      <SubHeading>
        To the member goes the Spoels!
      </SubHeading>
      <DescriptionDeals>We will have limited edition merchandise and giveaways for our community of Elts! <br/><ClickableSignIn onClick={checkTokenAndLogin}>Sign up</ClickableSignIn> to know more.</DescriptionDeals>
        {/* Modal for email confirmation */}
        <Modal
          open={modalOpen}
          onClose={handleModalClose}
          aria-labelledby="email-confirmation-modal"
          aria-describedby="email-confirmation-description"
        >
          <ModalContent style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',height: '100%' }}>
            <div style={{ textAlign: 'center' }}>
              <button onClick={handleModalClose} style={{ position: 'absolute', top: 10, right: 10, border: 'none', background: 'none', cursor: 'pointer' }}>
                <span style={{ fontSize: '20px', color: '#202023' }}>✖</span>
              </button>
              <ModalTitle>Use existing email?</ModalTitle>
              <ModalMessage>Do you want to use the email <strong>{email}</strong> to log in?</ModalMessage>
              <ButtonWrapper>
                <Button onClick={handleUseSameEmail} variant="contained">Use Same Email</Button>
                <Button onClick={handleUseDifferentEmail} style={{backgroundColor:"#fff"}} variant="outlined">Use Different Email</Button>
              </ButtonWrapper>
            </div>
          </ModalContent>
        </Modal>
    </div>
  );
  
}
const ModalContent = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  text-align: center;
`;

const ModalTitle = styled.h2`
  font-size: 24px;
  margin-bottom: 10px;
  color: #202023;
`;

const ModalMessage = styled.p`
  font-size: 16px;
  margin-bottom: 20px;
  color: #606060;
`;
const ClickableSignIn = styled.span`
  background-color: #e9fe53;
  cursor: pointer;
`;
const ButtonWrapper = styled.div`
  display: flex;
  margin-top: 24px;
  gap: 5px;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: -0.28px;
  padding: 0 1px;
  
  @media (max-width: 991px) {
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
`;

const Button = styled.button`
  justify-content: space-between;
  border-radius: 1px;
  border: 1px solid rgba(32, 32, 35, 1);
  background-color: #e9fe53;
  display: flex;
  gap: 8px;
  padding: 16px 13px;
  font-family: Metrophobic, sans-serif;
  cursor: pointer;
  width:260px;  
  text-transform: uppercase;
  @media (max-width: 991px) {
   
    width: 96%;
  }

`;
function WallofElts() {
  return (
    <div>
      <MainHeading>Coming soon</MainHeading>
      <FeatureImage src={featureImage} alt="Feature" loading="lazy" />
      <SubHeading>
        Wall of elts!        
      </SubHeading>
      <DescriptionDeals>As a mark of appreciation f​or helping build our awesome community, <br /> The first 10,000 members​' names will be featured forever on our website!</DescriptionDeals>
    </div>
  );
}

// Styled components remain unchanged
const ProfileContainer = styled.main`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 400;
  padding: 60px 80px 36px;
  @media (max-width: 991px) {
    padding:  20px;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: center; /* Center the logo */
  align-items: center;
  width: 100%;
  padding: 0 20px;
  @media (max-width: 991px) {
    padding: 0 20px;
    justify-content: space-between; /* For mobile, keep the original layout */
  }
`;

const ProfileImage = styled.img`
  aspect-ratio: 4;
  object-fit: cover;
  width: 260px;
  max-width: 100%;
  margin-top: 20px;
  cursor: pointer;
  @media (max-width: 991px) {
    width: 100px; /* Smaller logo for mobile */
    margin-top: 10px;
  }
`;

const Hamburger = styled.div`
  display: none;
  @media (max-width: 991px) {
    display: block;
    cursor: pointer;
  }
`;

const HamburgerImg = styled.img`
  width: 30px;
  height: 30px;
`;

const Nav = styled.nav`
  display: flex;
  margin-top: 24px;
  gap: 20px; /* Reduced space between menu items */
  font-size: 16px;
  color: #202023;
  text-transform: uppercase;
  letter-spacing: -0.32px;
  line-height: 130%;
  justify-content: space-between;
  @media (max-width: 991px) {
    flex-direction: column;
    position: absolute;
    right: 0;
    margin-top: -20px;
    background-color: white;
    width: 60%;
    gap: 10px;
    justify-content: start;
    height: 100vh; /* Make the height of the mobile menu full */
    display: ${props => (props.$isOpen ? 'flex' : 'none')};
    background-color: ${props => (props.$isActive ? "#e9fe53" : "white")};
    z-index: 1000;
  }
`;

const NavItem = styled.span`
  font-family: Metrophobic, sans-serif;
  background-color: ${props => (props.isActive ? "#e9fe53" : "transparent")};
  justify-content: center;
  cursor: pointer;
  @media (max-width: 991px) {
    white-space: initial;
    padding: 5px 20px;
    background-color: ${props => (props.isActive ? "white" : "#transparent")};
  }
`;

const CloseButton = styled.button`
  @media (max-width: 991px) {
    font-family: Metrophobic, sans-serif;
    align-self: flex-end;
    background: none;
    border: none;
    font-size: 14px;
    cursor: pointer;
    margin-bottom: 20px;
    margin-top: 20px;
    margin-right: 20px;
  }
`;

const SocialSection = styled.section`
  align-self: stretch;
  display: flex;
  margin-top: auto;
  width: 100%;
  gap: 20px;
  font-size: 12px;
  @media (max-width: 991px) {
    flex-wrap: wrap;
    //margin-top: 40px;
  }
`;

const SocialInfo = styled.div`
  display: flex;
  gap: 9px;
  color: #202023;
  letter-spacing: -0.24px;
  line-height: 130%;
  @media (max-width: 991px) {
    text-align: center;
    align-self: center;
  }
`;

const SocialLabel = styled.div`
  font-family: Metrophobic, sans-serif;
  text-transform: uppercase;
`;

const SocialLink = styled.div`
  display: flex;
  gap: 5px;
  white-space: nowrap;
  @media (max-width: 991px) {
    white-space: initial;
    margin-left:10%
  }
`;

const SocialIcon = styled.img`
  aspect-ratio: 1;
  object-fit: cover;
  width: 12px;
  margin: auto 0;
`;

const SocialText = styled.div`
  font-family: Metrophobic, sans-serif;
`;

const Footer = styled.footer`
  color: #828282;
  font-family: Metrophobic, sans-serif;
  flex-grow: 1;
  text-align: right;
  margin-top: auto; /* Ensure footer is at the bottom */
  @media (max-width: 991px) {
    text-align: center;
    align-self: center;
  }
`;

//------------------------------Dealsboard--------------------------------//

const MainHeading = styled.h1`
  margin-top: 55px;
  text-align: center;
  font: 800 80px/108% Inter, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
    margin-top: 40px;
    font-size: 40px;
  }
`;

const FeatureImage = styled.img`
  aspect-ratio: 3.23;
  object-fit: contain;
  align-self: center;
  width: 586px;
  margin-top: 21px;
  max-width: 100%;
`;

const SubHeading = styled.h2`
  margin-top: 26px;
  text-align: center;
  font: 800 20px/108% Inter, sans-serif;
`;

const DescriptionDeals = styled.div`
  letter-spacing: -0.28px;
  margin-top: 13px;
  text-align: center;
  font: 14px/130% Metrophobic, sans-serif;
`;
